export default "__VITE_ASSET__CCOw4F1z__"